"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const webapi_1 = require("@fegobull/webapi");
const qrcode_1 = tslib_1.__importDefault(require("qrcode"));
const swiper_1 = tslib_1.__importDefault(require("swiper"));
require("swiper/css");
require("swiper/css/pagination");
const modules_1 = require("swiper/modules");
const vue_demi_1 = require("vue-demi");
const i18n_1 = tslib_1.__importDefault(require("../../../i18n"));
const request_1 = tslib_1.__importDefault(require("../../assets/scripts/request"));
const utils_1 = require("../../common/utils");
const CancelConfirmDialog_vue_1 = tslib_1.__importDefault(require("./CancelConfirmDialog.vue"));
// 获取 PC 端判断
// 预约记录展示状态枚举
var DisplayStatus;
(function (DisplayStatus) {
    DisplayStatus["SUCCESS"] = "success";
    // 预约成功（待签到）
    DisplayStatus["SIGNED"] = "signed";
    // 已签到
    DisplayStatus["EXPIRED"] = "expired";
    // 已过期（违约）
    DisplayStatus["CANCELED"] = "canceled";
    // 已取消
    DisplayStatus["FAILED"] = "failed"; // 预约失败
})(DisplayStatus || (DisplayStatus = {}));
// Props 定义
const __sfc_main = {};
__sfc_main.props = {
    reservationList: {
        key: "reservationList",
        required: true,
        type: Array
    },
    configData: {
        key: "configData",
        required: true,
        type: null
    },
    moduleName: {
        key: "moduleName",
        required: true,
        type: String
    },
    reserveMoreImage: {
        key: "reserveMoreImage",
        required: false,
        type: String
    },
    initialSlide: {
        key: "initialSlide",
        required: false,
        type: Number
    },
    hasAvailableTimeSlot: {
        key: "hasAvailableTimeSlot",
        required: false,
        type: Boolean
    },
    showInviteBtn: {
        key: "showInviteBtn",
        required: false,
        type: Boolean
    }
};
__sfc_main.setup = (__props, __ctx) => {
    const { usePageType } = webapi_1.use;
    const { isPC } = usePageType();
    const props = __props;
    // Emits 定义
    const emit = __ctx.emit;
    // Swiper 相关
    const swiperRef = (0, vue_demi_1.ref)(null);
    const swiperPaginationRef = (0, vue_demi_1.ref)(null);
    let swiperInstance = null;
    // 二维码 URL 缓存
    const qrcodeUrls = (0, vue_demi_1.ref)({});
    // 取消确认弹窗相关
    const cancelDialogVisible = (0, vue_demi_1.ref)(false);
    const pendingCancelRecord = (0, vue_demi_1.ref)(null);
    // 轮询相关
    let pollingTimer = null;
    const currentSlideIndex = (0, vue_demi_1.ref)(0);
    /**
     * 当前激活的预约记录（PC 端按钮区域使用）
     */
    const activeRecord = (0, vue_demi_1.computed)(() => {
        const index = currentSlideIndex.value;
        if (index >= 0 && index < props.reservationList.length) {
            return props.reservationList[index];
        }
        return null;
    });
    /**
     * 当前是否展示"预约更多"卡片（PC 端按钮区域使用）
     * 需要配置了预约更多图片才会有"更多"卡片
     */
    const isMoreCardActive = (0, vue_demi_1.computed)(() => {
        return props.reserveMoreImage && currentSlideIndex.value >= props.reservationList.length;
    });
    /**
     * 是否为紧凑单时段模式（单项目 + 单日期 + 同日单时段规则）
     */
    const isCompactSingleSlotMode = (0, vue_demi_1.computed)(() => {
        const list = props.configData.list;
        if (list.length !== 1) {
            return false;
        }
        const activity = list[0];
        const spec = activity.limitRule.ruleSpec;
        if (spec.projectScope !== 'unique' || spec.dateScope !== 'unique' || spec.slotScope !== 'unique') {
            return false;
        }
        if (activity.availableDates.length !== 1) {
            return false;
        }
        return true;
    });
    /**
     * 是否启用紧凑按钮矩阵：配置满足且当前仅 1 条预约记录
     */
    const useCompactButtonMode = (0, vue_demi_1.computed)(() => {
        return isCompactSingleSlotMode.value && props.reservationList.length === 1;
    });
    /**
     * 毫秒转秒的除数
     */
    const MS_PER_SECOND = 1000;
    /**
     * 获取当前时间戳（秒）
     */
    const getNowUnix = () => Math.floor(Date.now() / MS_PER_SECOND);
    /**
     * 获取活动配置
     */
    const getActivityConfig = (record) => {
        return props.configData.list.find(item => item.activityKey === record.activity_key);
    };
    /**
     * 获取展示状态
     * 优先使用后端返回的 displayStatus，如果不存在则本地计算。
     * 简化规则：过了签到时间且 record.shouldSign 为 false 时，一律展示为已签到。
     */
    const getDisplayStatus = (record) => {
        const statusMap = {
            waiting: DisplayStatus.SUCCESS,
            checkin: DisplayStatus.SUCCESS,
            signed: DisplayStatus.SIGNED,
            expired: DisplayStatus.EXPIRED,
            canceled: DisplayStatus.CANCELED,
            failed: DisplayStatus.FAILED,
            confirming: DisplayStatus.FAILED
        };
        let status = statusMap[record.displayStatus] || DisplayStatus.FAILED;
        // 过了签到时间且不需要签到（record.shouldSign 为 false）→ 展示为已签到
        if (record.shouldSign === false) {
            const now = getNowUnix();
            const signStart = record.sign_start;
            const signEnd = record.sign_end;
            const pastSignTime = signStart !== undefined && now >= signStart || signEnd !== undefined && now >= signEnd;
            if (pastSignTime) {
                status = DisplayStatus.SIGNED;
            }
        }
        return status;
    };
    /**
     * 获取状态对应的 CSS 类名
     */
    const getStatusClass = (record) => {
        const status = getDisplayStatus(record);
        return `status-${status}`;
    };
    /**
     * 获取状态文本
     */
    const getStatusText = (record) => {
        const status = getDisplayStatus(record);
        const textMap = {
            [DisplayStatus.SUCCESS]: (0, i18n_1.default)('status_success'),
            [DisplayStatus.SIGNED]: (0, i18n_1.default)('status_signed'),
            [DisplayStatus.EXPIRED]: (0, i18n_1.default)('status_expired'),
            [DisplayStatus.CANCELED]: (0, i18n_1.default)('status_canceled'),
            [DisplayStatus.FAILED]: (0, i18n_1.default)('status_failed')
        };
        return textMap[status] || '';
    };
    /**
     * 获取活动名称
     */
    const getActivityName = (record) => {
        const activity = getActivityConfig(record);
        if (!activity) {
            return (0, i18n_1.default)('no_data');
        }
        const name = (0, utils_1.getLocalText)(activity.localText, 'name');
        return name || (0, i18n_1.default)('no_data');
    };
    /**
     * 获取活动地址
     */
    const getActivityAddress = (record) => {
        const activity = getActivityConfig(record);
        if (!activity) {
            return (0, i18n_1.default)('no_data');
        }
        const address = (0, utils_1.getLocalText)(activity.localText, 'address');
        return address || (0, i18n_1.default)('no_data');
    };
    /**
     * 获取时段信息（从配置中查找）
     */
    const getTimeSlotInfo = (record) => {
        const activity = getActivityConfig(record);
        if (!activity) {
            return null;
        }
        // 查找对应日期
        const dateSlot = activity.availableDates.find(dateItem => dateItem.date === record.date);
        if (!dateSlot) {
            return null;
        }
        // 查找对应时段
        return dateSlot.timeRanges.find(t => t.rangeKey === record.range_key);
    };
    /**
     * 格式化预约时间
     */
    const formatRecordTime = (record) => {
        const dateStr = record.date || '';
        if (!dateStr) {
            return (0, i18n_1.default)('no_data');
        }
        // 格式化日期（多语言，跨年展示年份）
        const dateFormatted = (0, utils_1.formatDateShort)(dateStr);
        // 从配置中获取时段的活动时间
        const timeSlot = getTimeSlotInfo(record);
        if (timeSlot) {
            return `${dateFormatted} ${timeSlot.start} - ${timeSlot.end}`;
        }
        return `${dateFormatted} ${record.activityStartTime} - ${record.activityEndTime}`;
    };
    /**
     * 是否展示二维码
     * 预约成功 + 已签到 状态都展示
     */
    const shouldShowQrcode = (record) => {
        const status = getDisplayStatus(record);
        return status === DisplayStatus.SUCCESS || status === DisplayStatus.SIGNED;
    };
    /**
     * 是否展示邀请按钮
     */
    const shouldShowInviteBtn = (record) => {
        if (props.showInviteBtn === false) {
            return false;
        }
        const status = getDisplayStatus(record);
        return status === DisplayStatus.SUCCESS || status === DisplayStatus.SIGNED;
    };
    /**
     * 是否展示新增预约按钮
     */
    const shouldShowAddReservationBtn = (record) => {
        if (!useCompactButtonMode.value) {
            return true;
        }
        const status = getDisplayStatus(record);
        return status === DisplayStatus.CANCELED;
    };
    /**
     * 是否展示取消按钮
     */
    const shouldShowCancelBtn = (record) => {
        const status = getDisplayStatus(record);
        if (useCompactButtonMode.value) {
            return status === DisplayStatus.SUCCESS;
        }
        return status === DisplayStatus.SUCCESS;
    };
    /**
     * 是否可以取消
     * 优先使用后端返回的 canCancel，如果不存在则本地计算
     */
    const canCancel = (record) => {
        // 优先使用后端返回的 canCancel
        if (record.canCancel !== undefined) {
            return record.canCancel;
        }
        // 兜底：本地计算
        const now = getNowUnix();
        const timeSlot = getTimeSlotInfo(record);
        if (timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.cancelEnd) {
            // 使用配置中的 cancelEnd 精确判断
            return now < timeSlot.cancelEnd;
        }
        // 配置不存在，不允许取消
        return false;
    };
    /**
     * 生成二维码
     */
    const generateQrcode = async (record) => {
        if (qrcodeUrls.value[record.id]) {
            return;
        }
        try {
            // 生成二维码内容（JSON 字符串）
            const uid = record.uid;
            const recordId = record.id;
            const qrcodeContent = JSON.stringify({
                uid,
                id: recordId
            });
            // 生成二维码图片
            const dataUrl = await qrcode_1.default.toDataURL(qrcodeContent, {
                width: 200,
                margin: 2,
                errorCorrectionLevel: 'M'
            });
            // 使用创建新对象的方式确保响应式更新
            qrcodeUrls.value = Object.assign(Object.assign({}, qrcodeUrls.value), { [record.id]: dataUrl });
        }
        catch (error) {
            console.error('[ReservationResult] 生成二维码失败:', error);
        }
    };
    /**
     * 为所有需要展示二维码的记录生成二维码
     */
    const generateAllQrcodes = () => {
        props.reservationList.forEach(record => {
            if (shouldShowQrcode(record)) {
                generateQrcode(record);
            }
        });
    };
    /**
     * 停止轮询
     */
    const stopPolling = () => {
        if (pollingTimer) {
            clearInterval(pollingTimer);
            pollingTimer = null;
        }
    };
    /**
     * 开始轮询签到状态
     */
    const startPolling = () => {
        if (pollingTimer) {
            return;
        }
        // TODO: 实现轮询逻辑
    };
    /**
     * 判断是否需要开始轮询
     */
    const startPollingIfNeeded = () => {
        // 获取当前展示的记录
        const currentIndex = currentSlideIndex.value;
        if (currentIndex >= props.reservationList.length) {
            return; // 当前是"预约更多"卡片
        }
        const currentRecord = props.reservationList[currentIndex];
        const status = getDisplayStatus(currentRecord);
        // 只有预约成功（待签到）状态且展示二维码时才轮询
        if (status === DisplayStatus.SUCCESS && shouldShowQrcode(currentRecord)) {
            startPolling();
        }
    };
    /**
     * 初始化 Swiper
     * @param overrideInitialSlide 覆盖初始位置（用于列表变化后恢复位置）
     */
    const initSwiper = (overrideInitialSlide) => {
        if (!swiperRef.value) {
            return;
        }
        // 确定初始位置：优先使用覆盖值，其次使用 prop，默认为 0
        const initialSlideValue = overrideInitialSlide !== undefined ? overrideInitialSlide : props.initialSlide || 0;
        // PC 端和移动端使用不同的 Swiper 配置
        const swiperConfig = isPC ? {
            // PC 端配置：active 卡片居中，能看到其他卡片一部分
            modules: [modules_1.Pagination],
            slidesPerView: 'auto',
            spaceBetween: 20,
            centeredSlides: true,
            initialSlide: initialSlideValue,
            pagination: {
                el: swiperPaginationRef.value,
                clickable: true
            },
            on: {
                slideChange: (swiper) => {
                    currentSlideIndex.value = swiper.activeIndex;
                    stopPolling();
                    startPollingIfNeeded();
                }
            }
        } : {
            // 移动端配置：单卡片展示
            modules: [modules_1.Pagination],
            slidesPerView: 1,
            spaceBetween: 16,
            centeredSlides: true,
            initialSlide: initialSlideValue,
            pagination: {
                el: swiperPaginationRef.value,
                clickable: true
            },
            on: {
                slideChange: (swiper) => {
                    currentSlideIndex.value = swiper.activeIndex;
                    stopPolling();
                    startPollingIfNeeded();
                }
            }
        };
        swiperInstance = new swiper_1.default(swiperRef.value, swiperConfig);
        // 同步当前索引
        currentSlideIndex.value = initialSlideValue;
    };
    /**
     * 销毁 Swiper
     */
    const destroySwiper = () => {
        if (swiperInstance) {
            swiperInstance.destroy();
            swiperInstance = null;
        }
    };
    /**
     * 处理邀请好友
     */
    const handleInvite = (record) => {
        emit('invite', record);
    };
    /**
     * 点击取消预约按钮，显示确认弹窗
     */
    const handleCancel = (record) => {
        if (!canCancel(record)) {
            return;
        }
        // 保存待取消的记录，显示确认弹窗
        pendingCancelRecord.value = record;
        cancelDialogVisible.value = true;
    };
    /**
     * 确认取消预约
     */
    const confirmCancel = async () => {
        if (!pendingCancelRecord.value) {
            return;
        }
        try {
            await request_1.default.cancelReservation({
                moduleName: props.moduleName,
                recordId: pendingCancelRecord.value.id
            });
            emit('canceled', pendingCancelRecord.value);
        }
        catch (error) {
            console.error('[ReservationResult] 取消预约失败:', error);
        }
        finally {
            pendingCancelRecord.value = null;
            cancelDialogVisible.value = false;
        }
    };
    /**
     * 处理预约更多
     */
    const handleReserveMore = () => {
        emit('reserve-more');
    };
    // 监听预约列表变化，重新生成二维码
    (0, vue_demi_1.watch)(() => props.reservationList, (newList, oldList) => {
        (0, vue_demi_1.nextTick)(() => {
            generateAllQrcodes();
            // 只有列表长度变化时才重新初始化 Swiper
            // 属性变化（如 canceled_at）不需要重新初始化
            if (newList.length !== (oldList === null || oldList === void 0 ? void 0 : oldList.length)) {
                const currentIndex = currentSlideIndex.value;
                destroySwiper();
                (0, vue_demi_1.nextTick)(() => {
                    // 恢复到之前的位置（如果有效），否则使用 0
                    const targetIndex = currentIndex < newList.length + 1 ? currentIndex : 0;
                    initSwiper(targetIndex);
                });
            }
        });
    }, {
        deep: true
    });
    (0, vue_demi_1.onMounted)(() => {
        generateAllQrcodes();
        (0, vue_demi_1.nextTick)(() => {
            initSwiper();
            startPollingIfNeeded();
        });
    });
    (0, vue_demi_1.onBeforeUnmount)(() => {
        stopPolling();
        destroySwiper();
    });
    return {
        $t: i18n_1.default,
        isPC,
        swiperRef,
        swiperPaginationRef,
        qrcodeUrls,
        cancelDialogVisible,
        activeRecord,
        isMoreCardActive,
        getStatusClass,
        getStatusText,
        getActivityName,
        getActivityAddress,
        formatRecordTime,
        shouldShowQrcode,
        shouldShowInviteBtn,
        shouldShowAddReservationBtn,
        shouldShowCancelBtn,
        canCancel,
        handleInvite,
        handleCancel,
        confirmCancel,
        handleReserveMore
    };
};
__sfc_main.components = Object.assign({
    CancelConfirmDialog: CancelConfirmDialog_vue_1.default
}, __sfc_main.components);
exports.default = __sfc_main;
//# sourceMappingURL=data:application/json;base64,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